import { memo } from 'react';
import { Globe, Mail, MessageSquare, Send, Phone } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ISourceBadgeProps } from '@/@types/leads';

const sourceConfig: Record<string, { icon: React.ReactNode; label: string; className: string }> = {
  website: {
    icon: <Globe className="w-3 h-3" />,
    label: 'Website',
    className: 'bg-link/10 text-link',
  },
  email: {
    icon: <Mail className="w-3 h-3" />,
    label: 'Email',
    className: 'bg-muted text-muted-foreground',
  },
  whatsapp: {
    icon: <Phone className="w-3 h-3" />,
    label: 'WhatsApp',
    className: 'bg-secondary text-secondary-foreground',
  },
  telegram: {
    icon: <Send className="w-3 h-3" />,
    label: 'Telegram',
    className: 'bg-link/10 text-link',
  },
  facebook: {
    icon: <Globe className="w-3 h-3" />,
    label: 'Facebook',
    className: 'bg-link/10 text-link',
  },
  instagram: {
    icon: <Globe className="w-3 h-3" />,
    label: 'Instagram',
    className: 'bg-destructive/10 text-destructive',
  },
  tiktok: {
    icon: <Globe className="w-3 h-3" />,
    label: 'TikTok',
    className: 'bg-muted text-muted-foreground',
  },
  organic: {
    icon: <Globe className="w-3 h-3" />,
    label: 'Organic',
    className: 'bg-secondary text-secondary-foreground',
  },
  ad: {
    icon: <Globe className="w-3 h-3" />,
    label: 'Ad',
    className: 'bg-accent-orange-bg text-accent-orange',
  },
  referral: {
    icon: <Globe className="w-3 h-3" />,
    label: 'Referral',
    className: 'bg-accent-orange-bg text-accent-orange',
  },
  website_chat: {
    icon: <MessageSquare className="w-3 h-3" />,
    label: 'Website Chat',
    className: 'bg-violet-500/10 text-violet-600',
  },
};

export const SourceBadge = memo(function SourceBadge({ source }: ISourceBadgeProps) {
  if (!source) return <span className="text-xs text-muted-foreground">—</span>;

  const config = sourceConfig[source];
  if (!config) return <span className="text-xs text-muted-foreground">{source}</span>;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium',
        config.className
      )}
    >
      {config.icon}
      {config.label}
    </span>
  );
});
